export default {
      id: "expand-query-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#expand-query-usage",
      toString: function () {
        return this.url;
      }
    }